import EndDateRecurrence from 'owa-service/lib/contract/EndDateRecurrence';
import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { DisplayDate, createDisplayDate } from 'owa-datetime';

export default function getRecurrenceEndDate(recurrence: RecurrenceType): DisplayDate {
    if (recurrence && recurrence.RecurrenceRange) {
        let endDateString = (recurrence.RecurrenceRange as EndDateRecurrence).EndDate;
        // if date string is used as it is, there is no time in string, so system takes timezone and there are chances of date getting modified.
        // passing hours, minutes, seconds as 0 will ensure the time zone is not impacted.
        if (endDateString) {
            let dateParts = endDateString.split(/(\+|-|T)/);
            return createDisplayDate(+dateParts[0], +dateParts[2] - 1, +dateParts[4], 0, 0, 0);
        }
    }

    return null;
}
